// extracted by mini-css-extract-plugin
export var cancelButton = "_m9-5";
export var content = "_m9-3";
export var createButton = "_m9-6";
export var drawerContainer = "_m9-0";
export var footer = "_m9-2";
export var header = "_m9-1";
export var orderFormColumn = "_m9-4";